import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import SideNavTitle from "./SideNavTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
    },
    "& label.Mui-focused": {
      color: "#823237",
    },
    "& .MuiInput-underline:not(.Mui-error):after": {
      borderBottomColor: "#823237",
    },
  },
}));

export default function Sidebar() {
  const classes = useStyles();
  const { register, handleSubmit, errors, reset } = useForm();
  const [tab, setTab] = React.useState("add1");
  const [sidebar, setSidebar] = useState([]);
  const [organization, setOrganization] = useState([]);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    axios.get("api/get_sidebar_detail", { signal: controller.signal }).then((res) => {
      if (!isMounted) return; //Guard skip state if unmounted
      if (res.data.status == "success") {
        setSidebar(res.data.data);
        setOrganization(res.data.organization);
      } else {
        setSidebar([]);
        setOrganization([]);
      }
    }).catch(error => {
        if (!isMounted) return;
      if (error.name !== "AbortError"  && error.name !== "CanceledError") {
        console.error("Failed to load sidebar data:", error);
      }
    });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const submitContactForm = (value) => {
    axios.post("/api/save_contact", value).then((resp) => {
      if (resp.data.status == "success") {
        $("#messages").html(resp.data.message);
        $("#messages").addClass("alert alert-success");
        reset({
          fullname: "",
          mobile_no: "",
          message: "",
          subject: "",
          email: "",
        });
      } else {
        $("#messages").html(resp.data.message);
        $("#messages").addClass("alert alert-danger");
      }
      setTimeout(() => {
        $("#messages").html("");
        $("#messages").removeClass("alert alert-danger");
      }, 4000);
    });
  };

  return (
    <div class="col-lg-4 col-md-12">
      <div class="service-sidebar">
        <div class="service-single-sidebar widget">
          <h2 class="widget-title">Quick Links</h2>
          <div class="menu-service-menu-container">
            <ul id="menu-service-menu" class="menu">
              {sidebar.length > 0
                ? sidebar.map((item, idx) => (
                    <li>
                      {/* <a href="#"> */}
                      <Link to={`/pages/${item.page_slug}`}>
                        {item.page_title}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <i className="fa fa-caret-right" />
                      </Link>
                      {/* </a> */}
                    </li>
                  ))
                : ""}
            </ul>
          </div>
        </div>
        <div class="service-single-sidebar widget">
          <h2 class="widget-title">Any further questions?</h2>
          <p>
            {organization.organization_name}
            <br />
            {organization.address1}
            <br />
            P.O. Box No. {organization.fax}
          </p>
          <h6>
            Call Us Now: {organization.phone}, {organization.mobile}
          </h6>
          <div class="contact-form-area service">
            <form
              className={classes.root}
              onSubmit={handleSubmit(submitContactForm)}
            >
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>Full Name</label>
                    <div class="icon">
                      <i class="fa fa-user" />
                    </div>
                    <input
                      type="text"
                      name="fullname"
                      ref={register({
                        required: "Required",
                      })}
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label>Your Email</label>
                    <div class="icon">
                      <i class="fa fa-envelope" />
                    </div>
                    <input
                      type="email"
                      name="email"
                      ref={register({
                        required: "Required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid Email Address",
                        },
                      })}
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label>Your Phone Number</label>
                    <div class="icon">
                      <i class="fa fa-phone" />
                    </div>
                    <input
                      type="number"
                      name="mobile_no"
                      ref={register({
                        required: "Required",
                      })}
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label>Type Subject</label>
                    <div class="icon">
                      <i class="fa fa-tag" />
                    </div>
                    <input
                      type="text"
                      name="subject"
                      ref={register({
                        required: "Required",
                      })}
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label>Message</label>
                    <div class="icon">
                      <i class="fa fa-pencil" />
                    </div>
                    <textarea
                      type="textarea"
                      name="message"
                      rows="5"
                      ref={register({
                        required: "Required",
                      })}
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div id="messages" />
                  <div class="form-group button">
                    <button type="submit" class="btn btn-primary">
                      Send Now
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
